import React, { useState } from "react";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import fb from "./ConfiguredFirebase";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: "35ch",
  },
  button: {
    marginTop: theme.spacing(3),
    width: "35ch",
  },
}));

function Login() {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [showPassword, setShowPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginViaEnter = () => {
    if (
      password !== "" &&
      email !== "" &&
      passwordError === "" &&
      emailError === ""
    ) {
      onLogin();
    }
  };

  const onLogin = () => {
    setIsLoading(true);
    fb.auth
      .signInWithEmailAndPassword(email, password)
      .then((authUser) => {
        if (!authUser.user.emailVerified) {
          throw new Error(
            "Account not activated yet: Use the link in the activation mail!"
          );
        }
        return;
      })
      .catch((error) => {
        console.error(error.message);
        reset();
      })
      .finally(() => setIsLoading(false));
  };

  const handlePassword = (event) => {
    let txt = event.target.value;
    setPassword(txt);
    let error = "";
    if (txt === "") {
      error = "Password can't be empty!";
    } else if (txt.length < 6) {
      error = "Password must be at least 6 characters long!";
    }
    setPassword(txt);
    setPasswordError(error);
  };

  const handleEmail = (event) => {
    let mailText = event.target.value.trim().toLowerCase();
    setEmail(mailText);
    let mailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let error = "";
    if (mailText === "") {
      error = "E-mail can't be empty!";
    } else if (!mailRe.test(mailText)) {
      error = "Invalid e-mail!";
    }
    setEmailError(error);
  };

  const handleClickShowPassword = () => {
    setShowPassword((last) => !last);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const reset = () => {
    setEmail("");
    setPassword("");
    setShowPassword(false);
    setEmailError("");
    setPasswordError("");
    setIsLoading(false);
  };

  return (
    <Container>
      <Grid container direction="column" justify="center">
        <FormControl className={clsx(classes.margin, classes.textField)}>
          <TextField
            className={clsx(classes.margin, classes.textField)}
            error={emailError !== ""}
            helperText={emailError}
            label="E-mail"
            id="email"
            placeholder="E-mail"
            value={email}
            onChange={handleEmail}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleLoginViaEnter();
              }
            }}
          />
          <TextField
            className={clsx(classes.margin, classes.textField)}
            error={passwordError !== ""}
            helperText={passwordError}
            label="Password"
            id="password"
            placeholder="Password"
            value={password}
            type={showPassword ? "text" : "password"}
            onChange={handlePassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleLoginViaEnter();
              }
            }}
          />
          {isLoading ? (
            <CircularProgress color="secondary" />
          ) : (
            <Button
              className={clsx(classes.margin, classes.button)}
              color="primary"
              type="submit"
              disabled={
                password === "" ||
                email === "" ||
                passwordError !== "" ||
                emailError !== ""
              }
              onClick={onLogin}
            >
              Login
            </Button>
          )}
        </FormControl>
      </Grid>
    </Container>
  );
}

export default Login;
